function initDeleteModal() {
  console.log("🧩 initDeleteModal cargado");

  let deleteUrl = null;

  // Delegado: asegura que funciona aunque se renderice dinámicamente
  $(document).off("click.deleteLink").on("click.deleteLink", ".delete-link", function (e) {
    e.preventDefault();
    deleteUrl = $(this).attr("href");
    console.log("🧱 Click detectado, mostrando modal", deleteUrl);

    $("#confirmDeleteModal")
      .modal({
        closable: true,
      })
      .modal("show");
  });

  // Acción al confirmar
  $(document).off("click.modalOk").on("click.modalOk", "#confirmDeleteModal .ok.button", function () {
    if (deleteUrl) {
      console.log("✅ Confirmado, enviando DELETE a:", deleteUrl);
      Rails.ajax({
        url: deleteUrl,
        type: "DELETE",
        success: () => window.location.reload(),
        error: (err) => console.error("Error en DELETE:", err)
      });
    }
  });
}

// Ejecuta al cargar o tras HMR
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDeleteModal);
} else {
  initDeleteModal();
}

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    initDeleteModal();
  });
}